import React from "react";
import { StarIcon } from "lucide-react";
import { testimonials } from "../../data/content";
import { CtaButton } from "../CtaButton";
function Stars({
  size = "h-4 w-4"
}: {
  size?: string;
}) {
  return <div className="flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-249" data-mp="3mgiqi6u3idye">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className={`${size} fill-gold-400 text-gold-400`} aria-hidden="true" data-id="element-250" data-mp="3r8amiww0tbvx" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="bg-navy-950 px-5 py-16 text-white md:py-24" data-id="element-251" data-mp="429vqplu5np9">
      <div className="mx-auto max-w-5xl" data-id="element-252" data-mp="44np8u0varup">
        <h2 className="text-center font-serif text-3xl font-bold leading-tight md:text-5xl" data-id="element-253" data-mp="91milacpiuru">
          What other surgeons <em className="text-gold-400" data-id="element-254" data-mp="dznzppqkok0o">are saying</em>
        </h2>
        <div className="mt-6 flex flex-col items-center gap-2" data-id="element-255" data-mp="2atiuil2se6n5">
          <div className="flex items-center gap-3" data-id="element-256" data-mp="2avdffze25yr8">
            <span className="font-serif text-4xl font-extrabold text-gold-400" data-id="element-257" data-mp="2frkct3se21xk">4.9/5</span>
            <Stars size="h-5 w-5" data-id="element-258" data-mp="1sksui0uoh8r6" />
          </div>
          <p className="text-center text-[15px] text-navy-100" data-id="element-259" data-mp="1smm2bjh11z0r">Join thousands of professionals using structured rhinoplasty education tools</p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-260" data-mp="1ivrg2f3s6zfb">
          {testimonials.map(t => <li key={t.name} className="flex flex-col rounded-3xl bg-white p-6 text-ink" data-id="element-261" data-mp="1euflrw9ypq0s">
              <Stars data-id="element-262" data-mp="2bic7tgo65dje" />
              <blockquote className="mt-4 flex-1 text-[16px] leading-relaxed" data-id="element-263" data-mp="2bivg05o0onk8">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-3 border-t border-cream-200 pt-5" data-id="element-264" data-mp="26l3lr4zwgpcv">
                <img src={t.photo} alt={`Photo of ${t.name}`} className="h-14 w-14 rounded-full object-cover ring-2 ring-gold-400" loading="lazy" data-id="element-265" data-mp="22h5newiefikv" />
                <div data-id="element-266" data-mp="r3a9ts757hvr">
                  <p className="font-bold" data-id="element-267" data-mp="r3to8yxl3o51">{t.name}</p>
                  <p className="text-sm text-muted" data-id="element-268" data-mp="r179ofca08db">{t.country}</p>
                </div>
              </div>
            </li>)}
        </ul>

        <CtaButton className="mt-12" tone="dark" label="I want to use the MasterMap" data-id="element-269" data-mp="nmnw6ayfho96" />
      </div>
    </section>;
}